import { render, staticRenderFns } from "./OrbitTableSection.vue?vue&type=template&id=4142f6e7&scoped=true"
import script from "./OrbitTableSection.vue?vue&type=script&lang=ts"
export * from "./OrbitTableSection.vue?vue&type=script&lang=ts"
import style0 from "./OrbitTableSection.vue?vue&type=style&index=0&id=4142f6e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4142f6e7",
  null
  
)

export default component.exports